import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { feelingName, SECTION_IDS, SECTIONS } from "../../lib/sections";
import { FlipbookLink } from "../FlipbookLink";

const MENU_ITEM = "w-full px-5 py-2 text-left font-display text-lg text-[#2D1E3E] transition-colors duration-150 hover:bg-[#F3E8FF]";
import { openLetter } from "../../lib/hearts";

const PLACES = [
  { id: "hall", name: "The hall", line: "where the sunlight falls" },
  ...SECTION_IDS.map((id) => ({ id, name: feelingName(id), line: SECTIONS[id].line })),
  { id: "windows", name: "Living windows", line: "the pond, the two birds, the dream" },
  { id: "memory", name: "The Memory Wall", line: "sit for a while" },
];

export function RoomsMenu({ region, onPick, guided, onWalk, onAll }) {
  const [open, setOpen] = useState(false);
  useEffect(() => void window.dispatchEvent(new CustomEvent("afae-menu", { detail: open })), [open]);
  const pick = (id) => {
    setOpen(false);
    onPick(id);
  };
  return (
    <div className="fixed right-4 top-[7.6rem] z-[60] sm:right-[9.25rem] sm:top-6">
      <button
        data-testid="rooms-menu-toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="rounded-full border border-[#B39DDB]/60 bg-[#FBF7F2]/95 px-4 py-1.5 font-display text-lg text-[#2D1E3E] backdrop-blur-xl transition-colors duration-200 hover:border-[#7E57C2] hover:text-[#7E57C2]"
      >
        ✦ menu
      </button>
      <AnimatePresence>
        {open && (
          <motion.ul
            data-testid="rooms-menu"
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 max-h-[70vh] w-64 overflow-y-auto rounded-2xl border border-[#B39DDB]/50 bg-[#FBF7F2] py-2 shadow-[0_18px_40px_-20px_rgba(74,45,85,0.6)] backdrop-blur-xl"
          >
            {PLACES.map((p) => (
              <li key={p.id}>
                <button
                  data-testid={`rooms-menu-${p.id}`}
                  onClick={() => pick(p.id)}
                  className={`flex w-full flex-col items-start px-5 py-2 text-left transition-colors duration-150 hover:bg-[#F3E8FF] ${region === p.id ? "bg-[#F3E8FF]/70" : ""}`}
                >
                  <span className="font-display text-lg italic text-[#2D1E3E]">{p.name}</span>
                  <span className="font-hand text-base leading-none text-[#8A4F9E]">{p.line}</span>
                </button>
              </li>
            ))}
            <li className="mx-5 my-1 h-px bg-[#B39DDB]/40" />
            {[
              ["walk", guided ? "Walk freely" : "Guided glide", () => onWalk?.()],
              ["all", "See all paintings", () => onAll?.()],
              ["letter", "Write to Priyanka", () => openLetter()],
              ["map", "Map", () => window.dispatchEvent(new CustomEvent("afae-map"))],
              ["tour", "Take the guided tour", () => window.dispatchEvent(new CustomEvent("afae-tour"))],
              ["share", "Share the gallery", () => window.dispatchEvent(new CustomEvent("afae-share-gallery"))],
              ["memory", "The Memory Wall", () => window.__afaeSit?.()],
              ["about", "About Priyanka", () => window.open("/about", "_blank")],
              ["flipbook", "The Flipbook", null],
              ["leave", "Leave the gallery", () => window.dispatchEvent(new CustomEvent("afae-leave"))],
            ].map(([k, t, fn]) => (
              <li key={k} onClick={fn ? undefined : () => setOpen(false)}>
                {fn ? (
                  <button data-testid={`menu-${k}`} data-mode={k === "walk" ? (guided ? "guided" : "free") : undefined} onClick={() => { setOpen(false); fn(); }} className={MENU_ITEM}>
                    {t}
                  </button>
                ) : (
                  <FlipbookLink testid={`menu-${k}`} className={`block ${MENU_ITEM}`}>{t}</FlipbookLink>
                )}
              </li>
            ))}
          </motion.ul>
        )}
      </AnimatePresence>
    </div>
  );
}
